import { useMemo } from "react";
import type { ProductVariation } from "@/types/productVariations";
import type { SelectedTerms } from "@/features/productVariations/types";

const useVariationMatching = (
  inStockVariations: ProductVariation[],
  selectedTerms: SelectedTerms,
) => {
  const matchedVariation = useMemo(
    () =>
      inStockVariations.find((inStockV) =>
        inStockV.attributes.every(
          (attr) => attr.name in selectedTerms && attr.option === selectedTerms[attr.name],
        ),
      ) ?? null,
    [selectedTerms, inStockVariations],
  );

  const getMatchedVariationId = () => matchedVariation?.id ?? null;

  return { matchedVariation, getMatchedVariationId };
};

export default useVariationMatching;
